import React, {PureComponent, useContext} from 'react';
import {withTranslation} from "react-i18next";
import {toast} from "react-toastify";

import axios from "../../../axios-defaults";
import UserContext from '../../../context/user-context';

import Spinner from '../../../components/UI/Spinner';
import Input from "../../../components/UI/Input/Input";
import Popup from "reactjs-popup";
import {Link} from "react-router-dom";
import PersonnalInfos from "./PersonnalInfos";

class ManageAccount extends PureComponent {
    static contextType = UserContext;

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            resendLoading: false,
            formIsValid: false,
            profileFormVisible:false,
            passwordForm:{
                email: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'email',
                        placeholder: '',
                        name: 'current-email',
                        autoComplete: 'current-email',
                        id: 'txt_email',
                    },
                    label: "profile.email",
                    value:'',
                    defaultValue:'',
                    validationRules:{
                        required:true,
                        matchRegex:"^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$"
                    },
                    valid: true,
                    visible: true,
                    touched: false,
                    confirmField: 'confirmEmail',
                    errorMessages: {
                        required : "errors.fieldrequired",
                        matchRegex : "errors.validemail"
                    },
                    errorMessage: "errors.fieldrequired"
                },
                confirmEmail: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'email',
                        placeholder: '',
                        name: 'confirm-email',
                        autoComplete: 'confirm-email',
                        id: 'txt_confirm_email',
                    },
                    label: "profile.confirm_email",
                    value:'',
                    validationRules:{
                        matchRegex:"^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$",
                        match: 'email'
                    },
                    valid: true,
                    visible: false,
                    touched: false,
                    confirmiEditField: 'email',
                    errorMessages: {
                        matchRegex : "errors.validemail",
                        match : "errors.emailnotmatch"
                    },
                    errorMessage: "errors.fieldrequired"
                },
                currentPassword: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'password',
                        placeholder: '',
                        name: 'current-password',
                        autoComplete: 'current-password',
                        id: 'txt_password',
                    },
                    label: "profile.currentpassword",
                    value:'',
                    validationRules:{
                        required:false
                    },
                    valid: false,
                    visible: true,
                    touched: false,
                    errorMessage: "errors.fieldrequired",
                    errorMessages: {
                        required : "errors.fieldrequired",
                    },
                },
                newPassword: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'password',
                        placeholder: '',
                        name: 'new-password',
                        autoComplete: 'new-password',
                        id: 'txt_new_password',
						inputInfos: 'profile.newpassword_infos'
                    },
                    label: "profile.newpassword",
                    value:'',
                    visible: true,
                    validationRules:{
                        required:false},
                    valid: true,
                    touched: false,
                    errorMessage: "errors.fieldrequired",
                    errorMessages: {
                        required : "errors.fieldrequired",
                    },
                },
                confirmNewPassword: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'password',
                        placeholder: '',
                        name: 'password-confirm',
                        autoComplete: 'password-confirm',
                        id: 'txt_password_confirm',
                    },
                    label: "profile.newpasswordconfirm",
                    value:'',
                    visible: true,
                    validationRules:{
                        match: 'newPassword'
                    },
                    valid: true,
                    touched: false,
                    errorMessage: "errors.passwordnotmatch",
                    errorMessages: {
                        match : "errors.passwordnotmatch",
                    },
                }
            }
        }
    }

    async componentDidMount() {
        const user = await axios.get(`/user`);
        this.fillForm(user.data.data);
    }

    btnAddSSOModal = (userContext) => {
        if (!userContext){
            return '';
        }
        const userInfos = userContext.user.infos;

        return (
            !userInfos.sso ?
            <Popup trigger={<Link to={"#"} className="link link--fs-14 link--accent link--red link--upper">
                <p><strong>{this.props.t('profile.btnaddsso')}&nbsp;&nbsp;<i className="fas fa-sign-in-alt"></i></strong></p>
            </Link>} modal>
                {close => (
                    <div className="popup-addsso">
                        <div className="content">{this.props.t("profile.confirm_addsso.content")}</div>

                        <div className="form-group row">
                            <div className="col-12 flex flex--justify-center">
                                <a href="/auth/microsoft-sso-redirect" className="btn btn--socials">
                                            <span className="social-icon"><i
                                                className="fab fa-microsoft fa-2x"></i></span>&nbsp;&nbsp;Microsoft
                                </a>
                            </div>
                            <div className="col-12 flex flex--justify-center">
                                <a href="/auth/google-sso-redirect"
                                   className="btn btn--socials"><span className="social-icon"><i
                                    className="fab fa-google fa-2x"></i></span>&nbsp;&nbsp;Google</a>
                            </div>
                            <div className="col-12 flex flex--justify-center">
                                <a href="/auth/apple-sso-redirect" className="btn btn--socials"><span
                                    className="social-icon"><i
                                    className="fab fa-apple fa-2x"></i></span>&nbsp;&nbsp;Apple</a>
                            </div>
                        </div>

                        <div className="actions">
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => {
                                    close();
                                }}
                            >{this.props.t('profile.confirm_addsso.cancel')}&nbsp;&nbsp;</button>
                        </div>
                    </div>
                )}
            </Popup>
                :null
        );
    }

    validateForm = () => {
        const updatedPasswordForm = {...this.state.passwordForm};
        let formIsValid = true;
        for(let inputIdentifier in updatedPasswordForm){
            if (updatedPasswordForm[inputIdentifier].elementConfigs.type == 'hidden')
                continue;

            const validationResult = this.checkValidity(updatedPasswordForm[inputIdentifier], updatedPasswordForm[inputIdentifier].value, updatedPasswordForm[inputIdentifier].validationRules);
            if (updatedPasswordForm[inputIdentifier].visible && !validationResult.valid){
                updatedPasswordForm[inputIdentifier].valid = false;
                updatedPasswordForm[inputIdentifier].touched = true;
                updatedPasswordForm[inputIdentifier].errorMessage = validationResult.errorMessages.join(', ')
            } else {
                updatedPasswordForm[inputIdentifier].valid = true;
                updatedPasswordForm[inputIdentifier].touched = false;
                updatedPasswordForm[inputIdentifier].errorMessage = '';
            }
            formIsValid = formIsValid && updatedPasswordForm[inputIdentifier].valid;
        }
        this.setState({
            passwordForm: updatedPasswordForm,
            formIsValid: formIsValid
        });
    }

    resetForm = () => {
        const userContext = this.context;
        const userInfos = userContext.user.infos;

        const updatedPasswordForm = {...this.state.passwordForm};

        for(let inputIdentifier in updatedPasswordForm){
            if (updatedPasswordForm[inputIdentifier].elementConfigs.type == 'hidden')
                continue;

            updatedPasswordForm['currentPassword'].value = '';
            updatedPasswordForm['currentPassword'].touched = false;
            updatedPasswordForm['newPassword'].value = '';
            updatedPasswordForm['newPassword'].touched = false;
            updatedPasswordForm['confirmNewPassword'].value = '';
            updatedPasswordForm['confirmNewPassword'].touched = false;
            updatedPasswordForm['email'].value = userInfos.email;
            updatedPasswordForm['email'].touched = false;
            updatedPasswordForm['confirmEmail'].value = '';
            updatedPasswordForm['confirmEmail'].visible = false;
            updatedPasswordForm['confirmEmail'].touched = false;
        }

        this.setState({
            passwordForm: updatedPasswordForm,
            formIsValid: false
        });
    }

    showProfileForm = () => {
        this.setState({
            profileFormVisible: true
        });
    }

    removeOwnership = () => {
    }

    hideProfileForm = () => {
        this.setState({
            profileFormVisible: false
        });
    }

    passwordChangedHandler = (e) => {
        e.preventDefault();

        this.validateForm();

        if(!this.state.formIsValid){
            return false;
            toast.error(
                <div>
                    <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t('profile.invalid_form')}
                </div>
            );
        }

        this.setState({loading:true});

        const {email,confirmEmail,currentPassword,newPassword,confirmNewPassword} = this.state.passwordForm;

        axios.put('/auth/update-profile',
            {
                email : email.value,
                email_confirmation : confirmEmail.value,
                old_password : currentPassword.value,
                password: newPassword.value,
                password_confirmation: confirmNewPassword.value
            })
            .then(response => {

                console.log('[ManageAccount.js] Change password Ajax raw response',response);
                if(response.data.succeeded){
                    let successMessages = [];
                    {Object.keys(response.data.message).forEach(function (key) {
                        successMessages.push(response.data.message[key]);
                    })}

                    toast.success(
                        <div>
                            <i className="fal fa-check-circle"></i>&nbsp;{successMessages.join('\n\r')}
                        </div>
                    );

                    this.resetForm();
                }
                else{
                    let errorMessages = [];
                    {Object.keys(response.data.errors).forEach(function (key) {
                        errorMessages.push(response.data.errors[key][0]);
                    })}

                    toast.error(
                        <div>
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp;{errorMessages.join('\n\r')}
                            </div>
                        </div>
                    );
                }
                this.setState({loading: false});
            }).catch(error => {
                if(error.response.data.errors){
                    let errorMessages = [];
                    {Object.keys(error.response.data.errors).forEach(function (key) {
                        errorMessages.push(error.response.data.errors[key][0]);
                    })}

                    toast.error(
                        <div>
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp;{errorMessages.join('\n\r')}
                            </div>
                        </div>
                    );
                }

                this.setState({loading: false});
            }
        );
    }

    resendValidationEmailHandler = (e) => {
        e.preventDefault();

        this.setState({resendLoading:true});

        axios.post('/auth/resend-verification-email',
            {})
            .then(response => {

                if(response.data.succeeded){
                    let successMessages = [];
                    {Object.keys(response.data.message).forEach(function (key) {
                        successMessages.push(response.data.message[key]);
                    })}

                    toast.success(
                        <div>
                            <i className="fal fa-exclamation-circle"></i>&nbsp;{successMessages.join('\n\r')}
                        </div>
                    );
                }
                this.setState({resendLoading: false});
            }).catch(error => {
                if(error.response.data.errors){
                    let errorMessages = [];
                    {Object.keys(error.response.data.errors).forEach(function (key) {
                        errorMessages.push(error.response.data.errors[key][0]);
                    })}

                    toast.error(
                        <div>
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp;{errorMessages.join('\n\r')}
                            </div>
                        </div>
                    );
                }

                this.setState({resendLoading: false});
            }
        );
    }


    checkValidity = (formElement,value,rules) => {
        let isValid = true;

        let errors = [];
        if(rules.required){
            const ruleValid = value.trim() !== ''
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.required))
            isValid = ruleValid && isValid;
        }

        if(rules.minLength){
            const ruleValid = value.length >= rules.minLength
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.minLength))
            isValid = ruleValid && isValid;
        }

        if(rules.maxLength){
            const ruleValid = value.length >= rules.maxLength
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.maxLength))
            isValid = value.length <= rules.maxLength && isValid;
        }

        if(rules.match){
            const ruleValid = this.state.passwordForm[rules.match].value === value
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.match))
            isValid = ruleValid && isValid;
        }

        if(rules.matchRegex){
            const ruleValid = value.match(rules.matchRegex) != null
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.matchRegex))
            isValid = ruleValid && isValid;
        }

        return {valid:isValid,errorMessages:errors};
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedPasswordForm = {...this.state.passwordForm};
        const updatedFormElement = {...updatedPasswordForm[inputIdentifier]}

        updatedFormElement.value = event.target.value;
        const validationResult = this.checkValidity(updatedFormElement, updatedFormElement.value, updatedFormElement.validationRules);
        updatedFormElement.valid = validationResult.valid
        if (validationResult.valid)
            updatedFormElement.errorMessage = "";
        else
            updatedFormElement.errorMessage = validationResult.errorMessages.join(', ');

        updatedFormElement.touched = true;

        updatedPasswordForm[inputIdentifier] = updatedFormElement;

        if (inputIdentifier == 'newPassword'){
            updatedPasswordForm['confirmNewPassword'].valid = updatedFormElement.value ==''?true:false;
            updatedPasswordForm['confirmNewPassword'].value = '';
        }

        if (inputIdentifier == 'email'){
            if (updatedFormElement.value == updatedFormElement.defaultValue){
                updatedPasswordForm['confirmEmail'].visible = false;
                updatedPasswordForm['confirmEmail'].value = '';
                updatedPasswordForm['confirmEmail'].valid = true;
                updatedPasswordForm['confirmEmail'].touched = false;
                updatedPasswordForm['confirmEmail'].errorMessage = '';
                updatedPasswordForm['newPassword'].validationRules.required = false;
                updatedPasswordForm['newPassword'].errorMessage = '';
                updatedPasswordForm['newPassword'].touched = false;
                updatedPasswordForm['currentPassword'].errorMessage = '';
                updatedPasswordForm['currentPassword'].touched = false;
            }
            else{
                updatedPasswordForm['confirmEmail'].visible = true;

                if (updatedPasswordForm['currentPassword'].visible){
                    updatedPasswordForm['currentPassword'].validationRules.required = true;
                }
                else{
                    updatedPasswordForm['newPassword'].validationRules.required = true;
                }
            }
            updatedPasswordForm['confirmEmail'].valid = true;
            updatedPasswordForm['confirmEmail'].value = '';
        }

        let formIsValid = true;
        for(let inputIdentifier in updatedPasswordForm){
            const userContext = this.context;
            const userInfos = userContext.user.infos;

            let inputValidity = updatedPasswordForm[inputIdentifier].valid
            if (!userInfos.has_password && inputIdentifier == 'currentPassword')
                inputValidity = true;

            formIsValid = inputValidity && formIsValid;
        }

        this.setState({
            passwordForm: updatedPasswordForm,
            formIsValid: formIsValid
        });
    }

    fillForm = (user) => {
        const updatedPasswordForm = {...this.state.passwordForm};
        const updatedFormElement = {...updatedPasswordForm['email']}

        updatedFormElement.value = user.email;
        updatedFormElement.defaultValue = user.email;
        updatedFormElement.valid = true;
        updatedPasswordForm['email'] = updatedFormElement;

        updatedPasswordForm['currentPassword'].visible = user.has_password;

        this.setState({
            passwordForm: updatedPasswordForm
        });
    };

    render() {
        const userContext = this.context;
        const userAccount = userContext.user.account;
        const userInfos = userContext.user.infos;

        let loading = (!(userAccount && userInfos));

        let content = '';

        if(!loading){
            let userAddress = Object.keys(userAccount.address).map(function(key, index) {
                if(userAccount.address[key]) return <span key={'address-line-'+index}>{userAccount.address[key]}<br/></span>
                return '';
            });

            const formElements = [];
            for(let key in this.state.passwordForm){
                let configs = this.state.passwordForm[key];

                formElements.push({
                    id: key,
                    configs: configs
                })
            }

            const loginType = this.props.t("profile."+userInfos.login_type)

            content = (
                <div className="manage-profile-tab">
                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="headline--block headline">{this.props.t("profile.infostitle")}</h3>

                            <PersonnalInfos
                                userInfos={userInfos}
                                userAccount={userAccount}
                                userAddress={userAddress} />
                        </div>

                        <div className="col-md-5  offset-md-1 mt-5 mt-md-0">
                            <h3 className="headline--block headline">{this.props.t("profile.idandpassword")}</h3>

                            {!this.state.profileFormVisible?
                                <div>
                                    {userInfos.pending_email_update ?
                                        <div className="btn-resend-verf-email">
                                            <button disabled={this.state.resendLoading?'disabled':''} onClick={this.resendValidationEmailHandler} className="btn btn--raised btn--raised--red">
                                                {this.props.t("profile.resendverif")}
                                                {(this.state.resendLoading ? <Spinner /> : null) }
                                            </button>
                                        </div>
                                        : null}
                                    <p>
                                        {userInfos.email}
                                    </p>
                                    <p>
                                        {this.props.t("profile.connected_with", {service:loginType})}
                                    </p>
                                    <p>
                                        <button type="submit" className="btn btn--outline" onClick={this.showProfileForm}>
                                            {this.props.t("profile.showformconnectbtn")}&nbsp;&nbsp;<i className="fas fa-angle-right"></i>
                                        </button>
                                    </p>
                                </div>:
                                <div>
                                    <div>
                                        <div className="form-group row">
                                            <div className="col-12 flex flex--justify-center">
                                                <a href="/auth/microsoft-sso-redirect" className="btn btn--socials">
                                            <span className="social-icon"><i
                                                className="fab fa-microsoft fa-2x"></i></span>&nbsp;&nbsp;Microsoft
                                                </a>
                                            </div>
                                            <div className="col-12 flex flex--justify-center">
                                                <a href="/auth/google-sso-redirect"
                                                   className="btn btn--socials"><span className="social-icon"><i
                                                    className="fab fa-google fa-2x"></i></span>&nbsp;&nbsp;Google</a>
                                            </div>
                                            <div className="col-12 flex flex--justify-center">
                                                <a href="/auth/apple-sso-redirect" className="btn btn--socials"><span
                                                    className="social-icon"><i
                                                    className="fab fa-apple fa-2x"></i></span>&nbsp;&nbsp;Apple</a>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <p>{this.props.t("profile.or")}</p>
                                    <hr/>
                                    <div>
                                        {userInfos.pending_email_update ?
                                            <div className="btn-resend-verf-email">
                                                <button disabled={this.state.resendLoading?'disabled':''} onClick={this.resendValidationEmailHandler} className="btn btn--raised btn--raised--red">
                                                    {this.props.t("profile.resendverif")}
                                                    {(this.state.resendLoading ? <Spinner /> : null) }
                                                </button>
                                            </div>
                                            : null}
                                        <form className="flex flex--direction-column form" onSubmit={() => { return false; }}>
                                            {formElements.filter(item => item.configs.visible).map(element => (
                                                <div key={element.id}>
                                                    {
                                                        element.configs.elementType == 'container'?
                                                            <div>
                                                                {element.configs.content(userContext)}
                                                            </div>
                                                            :
                                                            <Input key={element.id}
                                                                   label={element.configs.label}
                                                                   elementtype={element.configs.elementType}
                                                                   elementconfigs={element.configs.elementConfigs}
                                                                   value={element.configs.value}
                                                                   valid={element.configs.valid}
                                                                   shouldValidate={element.configs.validationRules}
                                                                   touched={element.configs.touched}
                                                                   changed={(event) => this.inputChangedHandler(event,element.id)}
                                                                   errorMessage={element.configs.errorMessage}/>
                                                    }
                                                </div>

                                            ))}
                                            <div className="form__action">
                                                <button type="submit" className="btn btn--outline" onClick={this.passwordChangedHandler}>
                                                    {this.props.t("profile.savebtn")}&nbsp;&nbsp;<i className="fas fa-angle-right"></i>
                                                </button>
                                                <button type="submit" className="btn btn--outline" onClick={this.hideProfileForm}>
                                                    {this.props.t("profile.cancelbtn")}&nbsp;&nbsp;<i className="fas fa-angle-right"></i>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            );
        } else {
            content = <Spinner />
        }

        return content;
    }
}

export default withTranslation()(ManageAccount);

